"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryFields = void 0;
/**
 * @summary Returns the queried fields of a GraphQL operation.
 *
 * Returns the queried fields of a GraphQL operation. If the given document does not contain an operation,
 * throws a `TypeError` instead.
 *
 * @param {DocumentNode} document
 * @returns {string[]}
 * @throws {TypeError}
 *
 * @see No example usage is available because of https://github.com/apollographql/apollo-tooling/issues/891
 */
function getQueryFields(document) {
    const op = document.definitions.find((d) => d.kind === 'OperationDefinition');
    if (!op) {
        throw new TypeError('The given document does not contain an operation definition.');
    }
    return op.selectionSet.selections.map((s) => s.name.value);
}
exports.getQueryFields = getQueryFields;
